import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

export const formatDateTime = (dateString) => {
  if (!dateString) return "";
  return dayjs(dateString).format("YYYY-MM-DD HH:mm:ss");
};

export const formatDate = (dateString) => {
  if (!dateString) return "";
  return dayjs(dateString).format("YYYY-MM-DD");
};

export const formatTime = (dateString) => {
  if (!dateString) return "";
  return dayjs(dateString).format("HH:mm:ss");
};

export const getRemainingTime = (deadline) => {
  if (!deadline) return null;

  const now = dayjs();
  const end = dayjs(deadline);
  const diff = end.diff(now);

  if (diff <= 0) {
    return { expired: true, display: "00:00:00" };
  }

  const dur = dayjs.duration(diff);
  const hours = Math.floor(dur.asHours());
  const minutes = dur.minutes();
  const seconds = dur.seconds();

  return {
    expired: false,
    hours,
    minutes,
    seconds,
    display: `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`,
    totalSeconds: Math.floor(diff / 1000),
  };
};

export const isEventOpen = (status) => {
  return status === "OPEN";
};

export const isEventEnded = (status) => {
  return status === "ENDED" || status === "CLOSED" || status === "DRAWN";
};

export const getEventStatusText = (status) => {
  const statusMap = {
    SCHEDULED: "대기 중",
    OPEN: "진행 중",
    PAUSED: "일시 중단",
    CLOSED: "마감",
    DRAWN: "추첨 완료",
    ENDED: "종료",
  };
  return statusMap[status] || status;
};
